import * as XLSX from "xlsx";
import moment from "moment";

// Sheet headers stay English regardless of the UI language -- same convention
// as skippedAccountsExport.js.
const ACCOUNT_NO_HEADER = "Account No";

/**
 * Build a one column sheet of the account numbers a bulk PDF export could not
 * render (`failedAccountNos` from the bulk-export status/list response) and
 * trigger an immediate download, so the operator can retry exactly those.
 * @param {Array<string|number>} failedAccountNos - Account numbers that failed.
 * @param {number|string} [exportId] - Included in the file name when provided.
 * @returns {boolean} False when there was nothing to write.
 */
export const downloadFailedAccountsExcel = (failedAccountNos, exportId) => {
  const accounts = (Array.isArray(failedAccountNos) ? failedAccountNos : [])
    .map((accountNo) => String(accountNo ?? "").trim())
    .filter(Boolean);

  if (accounts.length === 0) return false;

  const rows = accounts.map((accountNo) => ({ [ACCOUNT_NO_HEADER]: accountNo }));

  const worksheet = XLSX.utils.json_to_sheet(rows, { header: [ACCOUNT_NO_HEADER] });
  worksheet["!cols"] = [{ wch: 24 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Failed Accounts");
  XLSX.writeFile(
    workbook,
    `failed-accounts${exportId != null ? `-export-${exportId}` : ""}-${moment().format(
      "YYYY-MM-DD_HH-mm-ss"
    )}.xlsx`
  );

  return true;
};
